import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Calendar, Layout, message } from 'antd';
import "../CalenderView/CalendarView.css";
import axios from "axios";
import Cookies from "js-cookie";

const { Header, Content } = Layout;

const CalendarView = () => {
  const jwtToken = Cookies.get("jwt_token");
  const [value, setValue] = useState(dayjs());
  const [crawlingDates, setCrawlingDates] = useState([]);
  const [paydates, setPaydates] = useState([]);
  const [processdate, setProcessdates] = useState([]);

  const getAllCrawlingDates = async () => {
    try {
      axios({
        url:
          `${process.env.REACT_APP_BASE_URL}Auditlog/Getallcrawlingdates`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
        .then((resp) => {
          if (resp.data.statusCode == 200) {
            const response = JSON.parse(resp.data.payload)
            const formattedDates = response.map(date => dayjs(date).format('YYYY-MM-DD'));
            setCrawlingDates(formattedDates);
          }
        })

    }
    catch (error) {
      message.error("Unable to load data...")
    }
  };

  const getAllPaygDates = async () => {
    try {
      axios({
        url:
          `${process.env.REACT_APP_BASE_URL}Auditlog/GetallPaydates`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
        .then((resp) => {
          if (resp.data.statusCode == 200) {
            const response = JSON.parse(resp.data.payload)
            const formattedDates = response.map(date => dayjs(date).format('YYYY-MM-DD'));
            setPaydates(formattedDates);
          }
        })

    }
    catch (error) {
      message.error("Unable to load data...")
    }
  };


  const getAllProcessgDates = async () => {
    try {
      axios({
        url:
          `${process.env.REACT_APP_BASE_URL}Auditlog/GetallProcessingdates`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
        .then((resp) => {
          if (resp.data.statusCode == 200) {
            const response = JSON.parse(resp.data.payload)
            const formattedDates = response.map(date => dayjs(date).format('DD-MM-YYYY'));
            setProcessdates(formattedDates);
          }
        })

    }
    catch (error) {
      message.error("Unable to load data...")
    }
  };

  const onSelect = (newValue) => {
    setValue(newValue);
  };

  const onPanelChange = (newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getAllCrawlingDates();
    getAllPaygDates()
    getAllProcessgDates()
    // Hide the year dropdown
    const yearDropdowns = document.querySelectorAll('.ant-picker-calendar-year-select');
    if (yearDropdowns) {
      yearDropdowns.forEach((dropdown) => {
        dropdown.style.display = 'none';
      });
      const radioGroup = document.querySelector('.ant-radio-group-outline');
      if (radioGroup) {
        radioGroup.style.display = 'none';
      }
    }
  }, []);

  return (
    <>
      <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
        <SideNavBar />
        <Layout style={{ backgroundColor: "white" }}>
          <Header className="activity-header-class"><Navbar /></Header>
          <Content style={{ height: "100%", overflow: "auto" }}>
            <div className="pageview">
              <Calendar
                value={value}
                onSelect={onSelect}
                onPanelChange={onPanelChange}
                style={{ height: "70%" }}
                cellRender={(dateValue) => {
                  const formattedDate = dateValue.format('YYYY-MM-DD');
                  const formattedDate1 = dateValue.format('DD-MM-YYYY');
                  const isCrawlingDate = crawlingDates.includes(formattedDate);
                  const isPaydate = paydates.includes(formattedDate);
                  const isProcessdate = processdate.includes(formattedDate1);
                  return (
                    <>

                      <div style={{ background: isCrawlingDate ? 'orange' : '', borderRadius: isCrawlingDate ? '4px' : '0px' }}>
                        {isCrawlingDate && <span style={{ color: 'white', overflow: "none" }}>Crawl Day</span>}
                      </div>
                      <div style={{ background: isPaydate ? 'yellow' : '', borderRadius: isPaydate ? '4px' : '0px' }}>
                        {isPaydate && <span style={{ color: 'black' }}>Pay Day</span>}
                      </div>
                      <div style={{ background: isProcessdate ? 'gray' : '', borderRadius: isProcessdate ? '4px' : '0px' }}>
                        {isProcessdate && <span style={{ color: 'white' }}>Process Day</span>}
                      </div>

                    </>
                  );
                }}
              />
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default CalendarView;